var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShopIcon = function SvgShopIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M1.5 1.5h1.305c.81 0 1.448.697 1.38 1.5l-.622 7.47a2.097 2.097 0 0 0 2.092 2.272h7.987c1.08 0 2.026-.885 2.108-1.957l.405-5.625c.09-1.245-.855-2.258-2.108-2.258H4.365"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M12.188 16.5a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.875ZM6.188 16.5a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.875ZM6.75 6h9",
    opacity: 0.4
  })));
};
export default SvgShopIcon;